var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgErrorLicensePlates = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 198 123",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M193.52 95.081c-6.057-10.494-12.113-20.988-18.178-31.482-8.132-14.077-16.256-28.162-24.388-42.24-2.115-3.662-4.229-7.333-6.352-10.996-3.791-6.528-10.614-10.358-18.243-9.137-5.139.822-9.465 3.974-12.13 8.395-4.78 8.275-9.552 16.55-14.332 24.826a122148.29 122148.29 0 0 1-25.194 43.636c-2.833 4.908-5.666 9.808-8.499 14.716-2.442 4.237-4.652 8.371-4.126 13.518.926 9.05 8.54 15.577 17.509 15.665 3.623.04 7.254 0 10.877 0h86.569c6.185 0 11.899-1.668 15.817-6.831 4.605-6.073 4.357-13.67.663-20.07h.007Z",
  stroke: "url(#error-license-plates_svg__a)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M130.629 30.45c-2.283-.025-4.653-.184-6.816.662a9.564 9.564 0 0 0-5.785 6.679c-.599 2.578-.072 5.57.08 8.172.271 4.692.542 9.392.822 14.085l.742 12.688c.311 5.323 3.798 10.015 9.544 10.015 5.459-.223 9.153-4.237 9.52-9.568.224-3.264.384-6.536.567-9.8.447-7.629 1.157-15.29 1.333-22.927.135-5.81-4.333-9.959-10.007-10.007Z",
  stroke: "url(#error-license-plates_svg__b)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M138.896 96.621c-.399-5.1-4.389-9.273-9.68-9.297-5.283-.016-9.72 4.445-9.72 9.72s4.437 9.72 9.72 9.72 9.281-4.206 9.68-9.297c.024-.136.04-.271.04-.423 0-.151-.008-.295-.032-.423h-.008Z",
  stroke: "url(#error-license-plates_svg__c)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M102.342 81.248V54.999a6 6 0 0 0-6-5.999H7a6 6 0 0 0-6 6v26.248a6 6 0 0 0 6 5.999h89.344a6 6 0 0 0 5.999-6Z",
  fill: "#fff",
  stroke: "url(#error-license-plates_svg__d)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.8 80.448h87.737V55.806H7.8v24.642Z",
  stroke: "url(#error-license-plates_svg__e)",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "m21.173 71.303-.972 3.477H17l4.173-13.553h4.052l4.23 13.553h-3.323l-1.05-3.477h-3.909Zm3.459-2.292-.85-2.874c-.244-.802-.487-1.81-.687-2.61h-.043c-.2.8-.407 1.83-.628 2.61l-.808 2.874h3.016Z",
  fill: "url(#error-license-plates_svg__f)"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M31.277 61.412c.808-.164 2.451-.284 3.988-.284 1.886 0 3.037.177 4.03.766.95.504 1.636 1.426 1.636 2.654 0 1.227-.707 2.334-2.244 2.895v.043c1.558.418 2.716 1.589 2.716 3.335 0 1.227-.565 2.192-1.415 2.873-.993.788-2.651 1.228-5.367 1.228-1.522 0-2.65-.1-3.344-.199V61.412Zm3.059 5.187h1.014c1.622 0 2.494-.667 2.494-1.668 0-1-.793-1.568-2.186-1.568-.665 0-1.05.043-1.315.078v3.158h-.007Zm0 6.01c.307.042.671.042 1.193.042 1.4 0 2.63-.525 2.63-1.951 0-1.426-1.237-1.909-2.773-1.909h-1.05v3.818Z",
  fill: "url(#error-license-plates_svg__g)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M53.536 74.397c-.564.284-1.843.582-3.501.582-4.716 0-7.146-2.917-7.146-6.777 0-4.626 3.323-7.195 7.453-7.195 1.6 0 2.816.32 3.359.603l-.63 2.434a6.7 6.7 0 0 0-2.593-.504c-2.451 0-4.352 1.47-4.352 4.485 0 2.718 1.622 4.42 4.373 4.42.93 0 1.965-.198 2.573-.44l.464 2.392Z",
  fill: "url(#error-license-plates_svg__h)"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M60.139 68.486v2.03h-5.302v-2.03h5.302Z",
  fill: "url(#error-license-plates_svg__i)"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "m63.54 70.395-.021-.525c-.057-1.022.286-2.072 1.193-3.158.65-.766 1.172-1.405 1.172-2.093s-.464-1.164-1.479-1.206c-.672 0-1.48.24-2.008.603l-.686-2.193c.729-.426 1.944-.823 3.38-.823 2.673 0 3.887 1.469 3.887 3.136 0 1.526-.95 2.534-1.722 3.378-.75.823-1.05 1.61-1.036 2.512v.362h-2.694l.014.007Zm-.528 2.774c0-1.064.75-1.83 1.8-1.83s1.801.766 1.823 1.83c0 1.043-.73 1.831-1.823 1.831s-1.8-.78-1.8-1.83Z",
  fill: "url(#error-license-plates_svg__j)"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "m72.551 70.395-.021-.525c-.057-1.022.286-2.072 1.193-3.158.65-.766 1.172-1.405 1.172-2.093s-.464-1.164-1.48-1.206c-.67 0-1.478.24-2.007.603l-.686-2.193c.729-.426 1.944-.823 3.38-.823 2.672 0 3.887 1.469 3.887 3.136 0 1.526-.95 2.534-1.722 3.378-.75.823-1.05 1.61-1.036 2.512v.362h-2.694l.014.007Zm-.521 2.774c0-1.064.75-1.83 1.8-1.83s1.801.766 1.823 1.83c0 1.043-.73 1.831-1.823 1.831s-1.8-.78-1.8-1.83Z",
  fill: "url(#error-license-plates_svg__k)"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "m81.562 70.395-.021-.525c-.057-1.022.285-2.072 1.193-3.158.65-.766 1.172-1.405 1.172-2.093s-.465-1.164-1.48-1.206c-.671 0-1.478.24-2.007.603l-.686-2.193c.729-.426 1.943-.823 3.38-.823C85.785 61 87 62.469 87 64.136c0 1.526-.95 2.534-1.722 3.378-.75.823-1.05 1.61-1.036 2.512v.362h-2.694l.014.007Zm-.522 2.774c0-1.064.75-1.83 1.801-1.83 1.05 0 1.8.766 1.822 1.83 0 1.043-.728 1.831-1.822 1.831-1.093 0-1.8-.78-1.8-1.83Z",
  fill: "url(#error-license-plates_svg__l)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-license-plates_svg__a",
  x1: 2.5,
  y1: 106.541,
  x2: 197.08,
  y2: 106.541,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-license-plates_svg__b",
  x1: 2.5,
  y1: 106.541,
  x2: 197.08,
  y2: 106.541,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-license-plates_svg__c",
  x1: 2.5,
  y1: 106.541,
  x2: 197.08,
  y2: 106.541,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-license-plates_svg__d",
  x1: 1,
  y1: 68.123,
  x2: 195.5,
  y2: 68.123,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-license-plates_svg__e",
  x1: 0.872,
  y1: 68.127,
  x2: 196.5,
  y2: 68.127,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-license-plates_svg__f",
  x1: 1.5,
  y1: 68,
  x2: 193,
  y2: 68,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-license-plates_svg__g",
  x1: 1.5,
  y1: 68,
  x2: 193,
  y2: 68,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-license-plates_svg__h",
  x1: 1.5,
  y1: 68,
  x2: 193,
  y2: 68,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-license-plates_svg__i",
  x1: 1.5,
  y1: 68,
  x2: 193,
  y2: 68,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-license-plates_svg__j",
  x1: 1.5,
  y1: 68,
  x2: 193,
  y2: 68,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-license-plates_svg__k",
  x1: 1.5,
  y1: 68,
  x2: 193,
  y2: 68,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "error-license-plates_svg__l",
  x1: 1.5,
  y1: 68,
  x2: 193,
  y2: 68,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "red"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#005AAA"
})))));
export { SvgErrorLicensePlates as ReactComponent };
export default __webpack_public_path__ + "/assets/0e7600f03970f61326634adca62271ba.svg";